import { GoogleGenerativeAI } from "@google/generative-ai";
const API_KEY = "AIzaSyBhf2zEMpLvV56CQvjUi28KlgwUVducxwY";
const MODEL = "gemini-2.0-flash";
const genAI = new GoogleGenerativeAI(API_KEY);
const model = genAI.getGenerativeModel({ model: MODEL });

export const gemini = async (question = "") => {
    try {
        if (!question.trim()) {
            return ("Question cannot be empty.");
        }
        const result = await model.generateContent(question);
        return result.response.text(); // Adjust this as per actual API response structure
    } catch (error) {
        return "An error occurred while processing your request.";
    }
};